import React, { Component } from "react";
import { connect } from "react-redux";

import ArticlesListComponent from "./ArticlesListComponent";

import { fetchLatestArticles } from "Thunks";

import { LAYOUT_DISPOSITIONS } from "Config";

export class ArticlesList extends Component {
  componentDidMount() {
    const { fetchLatestArticles, disposition, conditions, order } = this.props;

    let limit = 0;
    for (const blocType of disposition || []) {
      limit += LAYOUT_DISPOSITIONS.BLOG[blocType];
    }
    fetchLatestArticles({
      limit: limit === 0 ? 15 : limit,
      isPublic: false,
      conditions,
      order
    });
  }

  render() {
    return <ArticlesListComponent {...this.props} />;
  }
}

// Connected Component
const mapStateToProps = (state, ownProps) => ({
  articles:
    state.articles.items && state.articles.items[ownProps.order]
      ? state.articles.items[ownProps.order]
      : [],
  fetching: state.articles.fetching,
  fetched: state.articles.fetched,
  lng: state.params.lng
  //navCommunity: state.auth.navCommunity
});

const mapDispatchToProps = dispatch => ({
  fetchLatestArticles: options => dispatch(fetchLatestArticles(options))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArticlesList);



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/ArticlesList/index.js